import styled from '@emotion/styled'
import {COLORS} from '../../constants'

/** Rounded card surface; its left border colour is set per depth inline. */
export const Card = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid ${COLORS.border};
  border-left-width: 4px;
  background-color: ${COLORS.cardBg};
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  transition: box-shadow 0.15s ease;

  &:hover {
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.1);
  }
`

/** Top section of the card: identity header on the left, actions on the right. */
export const TopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
`
